module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow04-7c7d17fbd70ab43801b4882e06753295.svg";